var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8504 13.8754C11.8504 14.4323 11.6291 14.9665 11.2353 15.3603C10.8415 15.7541 10.3073 15.9754 9.75039 15.9754C9.19344 15.9754 8.65929 15.7541 8.26547 15.3603C7.87164 14.9665 7.65039 14.4323 7.65039 13.8754C7.65039 13.3184 7.87164 12.7843 8.26547 12.3905C8.65929 11.9966 9.19344 11.7754 9.75039 11.7754C10.3073 11.7754 10.8415 11.9966 11.2353 12.3905C11.6291 12.7843 11.8504 13.3184 11.8504 13.8754Z",
    stroke: "white",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.875C15 18.8744 9.75 21.75 9.75 21.75C9.75 21.75 4.5 18.8744 4.5 13.875C4.5 12.4826 5.05312 11.1473 6.03769 10.1627C7.02226 9.17812 8.35761 8.625 9.75 8.625C11.1424 8.625 12.4777 9.17812 13.4623 10.1627C14.4469 11.1473 15 12.4826 15 13.875Z",
    stroke: "white",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 10.1429C16.5714 8.71429 16.4286 7.85714 15.8571 7.28571C15.2857 6.71429 14.4286 6.57143 13 6.57143C14.4286 6.57143 15.2857 6.42857 15.8571 5.85714C16.4286 5.28571 16.5714 4.42857 16.5714 3C16.5714 4.42857 16.7143 5.28571 17.2857 5.85714C17.8571 6.42857 18.7143 6.57143 20.1429 6.57143C18.7143 6.57143 17.8571 6.71429 17.2857 7.28571C16.7143 7.85714 16.5714 8.71429 16.5714 10.1429ZM21.5714 5.85714C21.6429 5.42857 21.5 5.07143 21.2857 4.71429C20.9286 4.5 20.5714 4.35714 20.1429 4.42857C20.5714 4.5 20.9286 4.35714 21.2857 4.14286C21.5 3.78571 21.6429 3.42857 21.5714 3C21.5 3.42857 21.6429 3.78571 21.8571 4.14286C22.2143 4.35714 22.5714 4.5 23 4.42857C22.5714 4.35714 22.2143 4.5 21.8571 4.71429C21.6429 5.07143 21.5 5.42857 21.5714 5.85714Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.714286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicLocation);
export default __webpack_public_path__ + "static/media/magicLocation.0567fbd241a39d22ab0dbe88ef2b181f.svg";
export { ForwardRef as ReactComponent };